import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const LPFooter = () => {
  return (
    <footer className="bg-[#2B0A12] text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Contact Info Section */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-8 pb-8 border-b border-gray-700">
          {/* Phone */}
          <a 
            href="tel:+18882031297" 
            className="flex items-center space-x-3 text-[#F1F1F1] hover:text-[#FFB400] transition-colors group"
          >
            <div className="w-12 h-12 bg-[#FFB400] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <Phone className="h-6 w-6 text-[#2B0A12]" />
            </div>
            <div>
              <p className="text-xs text-gray-400 uppercase tracking-wide">Call Us</p>
              <p className="text-lg font-bold">+1 (877) 317-1184</p>
            </div>
          </a>
          
          {/* Email */}
          <a 
            href="mailto:info@trademarkessential.com" 
            className="flex items-center space-x-3 text-[#F1F1F1] hover:text-[#FFB400] transition-colors group"
          >
            <div className="w-12 h-12 bg-[#D72638] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <Mail className="h-6 w-6 text-white" />
            </div>
            <div>
              <p className="text-xs text-gray-400 uppercase tracking-wide">Email Us</p>
              <p className="text-sm md:text-base font-semibold">info@trademarkessential.com</p>
            </div>
          </a>
          
          {/* Address */}
          <div className="flex items-center space-x-3 text-[#F1F1F1]">
            <div className="w-12 h-12 bg-gray-700 rounded-full flex items-center justify-center">
              <MapPin className="h-6 w-6 text-[#FFB400]" />
            </div>
            <div>
              <p className="text-xs text-gray-400 uppercase tracking-wide">Location</p>
              <p className="text-sm font-semibold">7060 Hollywood Blvd, Los Angeles, CA</p>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="text-center">
          <p className="text-sm">
            © 2026 Trademark Essential. All rights reserved.
          </p>
          <div className="mt-4 flex items-center justify-center space-x-6 text-sm">
            <a href="/privacy" className="hover:text-[#FFB400] transition-colors">Privacy Policy</a>
            <span className="text-gray-600">|</span>
            <a href="/terms" className="hover:text-[#FFB400] transition-colors">Terms of Service</a>
          </div>
          <p className="mt-4 text-xs text-gray-500">
            Trademark registration services provided by licensed attorneys.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LPFooter;
